const selectors = {
  giftProductList: '.free_upsell-card-products',
  giftItem: '.free_upsell-card-single-wrapper',
}

const dragToScroll = function(el){
  let isDown = false;
  let startX;
  let scrollLeft;
  
  el.addEventListener('mousedown', (e) => {
    isDown = true;
    el.classList.add('active');
    startX = e.pageX - el.offsetLeft;
    scrollLeft = el.scrollLeft;
  });
  el.addEventListener('mouseleave', () => {
    isDown = false;
    el.classList.remove('active');
  });
  el.addEventListener('mouseup', () => {
    isDown = false;
    el.classList.remove('active');
  });
  el.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const walk = (x - startX) * 1; //scroll-fast
    el.scrollLeft = scrollLeft - walk;
  });
}


document.addEventListener('cart:rerendered', function(){
  const slider = document.querySelectorAll(selectors.giftProductList);
  slider.forEach(el => {
    dragToScroll(el)
  })
});
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelectorAll(selectors.giftProductList);
  slider.forEach(el => {
    dragToScroll(el)
  })
});
